import {
  ADMIN_LOADING,
  ADMIN_ERROR,

  ADMIN_ROLES,
  ADMIN_FILTERS,
  ADMIN_LIST,
  ADMIN_DELETE
} from "actions/admin/constants";

const initialState = {
  loading: false,
  errors: [],

  list: {
    content: []
  },
  filters: [],
  roles: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADMIN_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case ADMIN_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case ADMIN_FILTERS:
      return {
        ...state,
        loading: false,
        errors: [],
        filters: action.payload.content,
      };
    case ADMIN_ROLES:
      return {
        ...state,
        loading: false,
        errors: [],
        roles: action.payload,
      };
    case ADMIN_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case ADMIN_DELETE:
      return {
        ...state,
        loading: false,
        errors: [],
        list: {
          ...state.list,
          content: state.list.content.filter(i => i.id !== action.payload)
        },
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/adminReducer.js